import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'nw-advisor-controls',
    templateUrl: './controls.component.html',
    styleUrl: './controls.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class AdvisorControlsComponent {}
